// UK money + date helpers (GBP).
export function gbp(amount) {
  const n = Number(amount || 0);
  return `£${n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)}`;
}

export function priceRange(listing) {
  if (!listing) return "";
  const from = listing.price_from ?? listing.price_min ?? listing.price;
  const to = listing.price_to ?? listing.price_max;
  if (to && to > from) return `${gbp(from)}–${gbp(to)}`;
  return gbp(from);
}

export function prettyDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
  } catch {
    return iso;
  }
}

// Next N calendar days as { iso, label, weekday, day } for date pickers.
export function nextDays(n = 14) {
  const out = [];
  const now = new Date();
  for (let i = 0; i < n; i++) {
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
    const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    out.push({
      iso,
      weekday: d.toLocaleDateString("en-GB", { weekday: "short" }),
      day: d.getDate(),
      month: d.toLocaleDateString("en-GB", { month: "short" }),
    });
  }
  return out;
}
